import type { SVGProps } from "react";
// generated from Table.svg — do not edit manually
// prettier-ignore
export default function Table(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 3 12 H 15 M 3 6 H 21 M 3 18 H 21" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
